export abstract class SubscriptionException extends Error {

}
